import { themeOptions } from '../themeOptions';
import {
  ThemeProvider,
  CssBaseline,
  Container,
} from '@mui/material';
import { FormspreeProvider } from '@formspree/react';
import { BrowserRouter } from 'react-router-dom';

//components
import Hero from './Hero/Hero';
import Projects from './Projects/Projects';
import Tooling from './Tooling/Tooling'
import Contact from './Contact/Contact';

function App() {

  return (
    <ThemeProvider theme={themeOptions}>
      <CssBaseline>
        <FormspreeProvider>
          <Container maxWidth="xl">
            <BrowserRouter>
              <Hero />
              <Projects />
              <Tooling />
              <Contact />
            </BrowserRouter>
          </Container>
        </FormspreeProvider>
      </CssBaseline>
    </ThemeProvider >
  );
}

export default App;
